/* eslint no-unused-vars: "off" */
export default function slideReset() {
  let speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  let runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let internal = arguments.length > 2 ? arguments[2] : undefined;
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}